import { render, staticRenderFns } from "./PanList.vue?vue&type=template&id=5fc9e906&scoped=true&"
import script from "./PanList.vue?vue&type=script&lang=js&"
export * from "./PanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc9e906",
  null
  
)

export default component.exports